import { get } from 'lodash'
import type { Listing } from '@adc/sdk/types'
import type { primitives } from '@adc/blueprint'

// TODO: add structures other than listing to standardTracking,
// also can add ability to track different subsets of listing based on whether we're tracking a save vs a select based on requirements.
interface StandardListingData {
  auctionNumber?: string | null
  productType?: string | null
  morpheusListingId?: string | null
  morpheusPropertyId?: string | null
  county?: string | null
  state?: string | null
  city?: string | null
  sellerCode?: string | null
}

interface StandardUserData {
  userId?: string
  partyId?: string
}

/**
 * This expects all fields in listing according to listingcard schema and expects it to be in listing structure that matches the same schema.
 *
 * standardTracking indicates the object which will hold the standard tracking objects for any structures needed,
 * for now just listing but conceivably other auction constructs tracking objects can be defined here.
 * @param listing - The listing object
 */
const listing = (listing: Listing): StandardListingData => {
  return {
    auctionNumber: get(listing, 'event.event_code'),
    productType: get(listing, 'listing_configuration.asset_type'),
    morpheusListingId: get(listing, 'listing_id'),
    morpheusPropertyId: get(listing, 'primary_property.property_id'),
    county: get(listing, 'seller_property.country_secondary_subdivision'),
    state: get(listing, 'seller_property.country_primary_subdivision'),
    city: get(listing, 'seller_property.municipality'),
    sellerCode: get(listing, 'program_configuration.program_enrollment_code'),
  }
}

const user = (user: primitives.AuctionUser): StandardUserData => {
  if (user.logged_in) {
    return {
      userId: get(user, 'user_id'),
      partyId: get(user, 'party_id'),
    }
  }
  return {
    userId: undefined,
    partyId: undefined,
  }
}

const standardTracking = {
  listing,
  user,
}

// Type exports
export type { StandardListingData, StandardUserData }

export default standardTracking
